import Event from "../models/Event.js";
import { getAuth } from "firebase/auth";
import axios from "axios";

const API_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net/get_events";
const MY_EVENTS_API = "https://europe-west3-hyper-e122e.cloudfunctions.net/get_my_events";
const TOGGLE_LIKE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net/toggle_event_like";
const CREATE_EVENT_API = "https://europe-west3-hyper-e122e.cloudfunctions.net/create_event";

export default class EventService {
  static async fetchAllEvents() {
    try {
      console.log("🚀 [fetchAllEvents] Начинаем загрузку ивентов...");

      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");

      console.log("🔐 Токен получен, отправляем запрос...");

      const response = await axios.get(API_URL, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      const result = response.data;

      if (!Array.isArray(result.events)) {
        throw new Error("❌ Неверный формат: поле 'events' не является массивом");
      }

      return result.events.map(eventJson => Event.fromJson(eventJson));

    } catch (error) {
      throw error;
    }
  }

  static async toggleLike(eventId) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");

      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");

      const response = await axios.post(
        TOGGLE_LIKE_URL,
        { event_id: eventId },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async uploadEventImage(file, eventId, renew = false) {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");
  
      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");
  
      // ⚙️ Собираем FormData для универсального upload_image
      const formData = new FormData();
      formData.append("type", "event_image");
      formData.append("user_id", currentUser.uid);
      formData.append("event_id", eventId);
      formData.append("renew_url", renew ? "true" : "false");
      formData.append("event_image", file); // 👈 ключ совпадает с form_field из upload_image
  
      console.log("📤 Загружаем event_image:", {
        eventId,
        userId: currentUser.uid,
        renew
      });
  
      const response = await axios.post(
        "https://europe-west3-hyper-e122e.cloudfunctions.net/upload_image",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );
  
      if (response.data.error) {
        throw new Error(response.data.error);
      }
  
      console.log("✅ Изображение ивента успешно загружено:", response.data);
      return response.data.url;
  
    } catch (error) {
      console.error("❌ Ошибка при загрузке изображения ивента:");
      console.error("➡️", error.response?.data || error.message);
      throw error;
    }
  }
  
  static async fetchEventById(eventId) {
    try {
      console.log(`🎯 [fetchEventById] Загружаем ивент: ${eventId}`);
  
      const auth = getAuth();
      const currentUser = auth.currentUser;
      if (!currentUser) throw new Error("❌ Пользователь не авторизован");
  
      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен");
  
      const response = await axios.get(`${API_URL}?event_id=${eventId}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });
  
      const result = response.data;
  
      if (!result.event) {
        throw new Error("❌ Backend не вернул поле 'event'");
      }
  
      console.log("✅ Ивент успешно получен:", result.event);
  
      return Event.fromJson(result.event);
  
    } catch (error) {
      console.error("❌ Ошибка fetchEventById:", error.response?.data || error.message);
      throw error;
    }
  }

  static async createEvent(payload) {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error("Пользователь не авторизован");
    }

    let token = await user.getIdToken(false);

    const doRequest = async (bearer) => {
      return axios.post(
        CREATE_EVENT_API,
        payload,
        {
          headers: {
            Authorization: `Bearer ${bearer}`,
            "Content-Type": "application/json",
          },
          timeout: 15000,
        }
      );
    };

    try {
      const res = await doRequest(token);
      return res.data;

    } catch (err) {

      // 🔄 если токен протух — обновляем
      if (err?.response?.status === 401) {
        token = await user.getIdToken(true);
        const res = await doRequest(token);
        return res.data;
      }

      console.error("❌ Ошибка создания ивента:", err?.response?.data || err);
      throw err;
    }
  }
  static async fetchMyEvents() {
    try {
      console.log(
        "📅 [fetchMyEvents] Загружаем мои ивенты..."
      );
  
      const auth =
        getAuth();
  
      await auth.authStateReady();
  
      const currentUser =
        auth.currentUser;
  
      if (!currentUser) {
        console.warn(
          "❌ Пользователь не авторизован → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return {
          pendingEvents: [],
          activeEvents: [],
          lastEvents: []
        };
      }
  
      const token =
        await currentUser.getIdToken();
  
      if (!token) {
        throw new Error(
          "❌ Не удалось получить токен"
        );
      }
  
      const response =
        await axios.get(
          MY_EVENTS_API,
          {
            headers: {
              "Content-Type":
                "application/json",
  
              Authorization:
                `Bearer ${token}`
            }
          }
        );
  
      const result =
        response.data;
  
      const pendingEvents =
        Array.isArray(
          result.pending_events
        )
          ? result.pending_events.map(
              eventJson =>
                Event.fromJson(
                  eventJson
                )
            )
          : [];
  
      const activeEvents =
        Array.isArray(
          result.active_events
        )
          ? result.active_events.map(
              eventJson =>
                Event.fromJson(
                  eventJson
                )
            )
          : [];
  
      const lastEvents =
        Array.isArray(
          result.last_events
        )
          ? result.last_events.map(
              eventJson =>
                Event.fromJson(
                  eventJson
                )
            )
          : [];
  
      console.log(
        "✅ [fetchMyEvents] Загружено:",
        {
          pending:
            pendingEvents.length,
  
          active:
            activeEvents.length,
  
          last:
            lastEvents.length
        }
      );
  
      return {
        pendingEvents,
        activeEvents,
        lastEvents
      };
  
    } catch (error) {
      if (
        error?.response?.status === 401
      ) {
        console.warn(
          "❌ Сессия недействительна → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return {
          pendingEvents: [],
          activeEvents: [],
          lastEvents: []
        };
      }
  
      console.error(
        "❌ Ошибка fetchMyEvents:",
        error.response?.data
        || error.message
      );
  
      throw error;
    }
  }

}